export const environment = {
  production: false,

  API: `https://api.decision-engine.io/`,
  // API: `https://dev.mobmaxime.com/ToTAPI-Phase2/`,
  //API: `https://localhost:7046/`,

  paging: {
		defaultPageSize: 10,
		lengthMenu: [10, 20, 50, 100]
	}
};
